import { AppStoresButton, Card, DownloadAppQRCode, PageContainer, Text, XStack } from '@frontend/web-react';
import { useAnalytics } from '@frontend/web/hooks';
import { createFileRoute } from '@tanstack/react-router';

const DownloadApp = () => {
  const { track } = useAnalytics();
  return (
    <PageContainer className="bg-neutral-50" headerTitle="Download App">
      <XStack className="gap-md">
        <Card
          // eslint-disable-next-line tailwindcss/no-arbitrary-value
          className="gap-y-md w-full max-w-[300px] items-center justify-center bg-trueWhite rounded-lg"
          padding="md"
          withBorder
        >
          <DownloadAppQRCode platform="ios" />
          <Text type="captionBold">Scan to download</Text>
          <AppStoresButton
            onClick={() => track({ event: 'iosDownloadLinkSelected', topic: 'onboarding' })}
            platform="ios"
          />
        </Card>
        <Card
          // eslint-disable-next-line tailwindcss/no-arbitrary-value
          className="gap-y-md w-full max-w-[300px] items-center justify-center bg-trueWhite rounded-lg"
          padding="md"
          withBorder
        >
          <DownloadAppQRCode platform="android" />
          <Text type="captionBold">Scan to download</Text>
          <AppStoresButton
            onClick={() => track({ event: 'androidDownloadLinkSelected', topic: 'onboarding' })}
            platform="android"
          />
        </Card>
      </XStack>
    </PageContainer>
  );
};

export const Route = createFileRoute('/app/settings/download-app')({
  component: DownloadApp,
});
